import { useMutation } from '../';
import { deleteCustomPortal } from '../mutations';

export function useDeleteCustomPortal() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(deleteCustomPortal, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
